import React from "react";

const cn = (...classes) => classes.filter(Boolean).join(" ");

export function RainbowButton({
  children,
  className,
  ...props
}) {
  return (
    <button
      className={cn(
        // Base styles
        "group relative inline-flex h-11 cursor-pointer items-center justify-center rounded-xl border-0 bg-[length:200%] px-8 py-2 font-medium text-black",
        
        // Transition
        "transition-all duration-300 ease-in-out",
        
        // Hover effects
        "hover:scale-105 hover:shadow-xl hover:shadow-black/20 hover:z-10",
        
        // Focus styles
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
        
        // Background and border styles
        "[background-clip:padding-box,border-box,border-box] [background-origin:border-box] [border:calc(0.08*1rem)_solid_transparent]",
        
        // Rainbow animation
        "animate-rainbow",

        // Before styles (glow effect)
        "before:absolute before:bottom-[-20%] before:left-1/2 before:z-0 before:h-1/5 before:w-3/5 before:-translate-x-1/2 before:animate-rainbow before:bg-[linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))] before:bg-[length:200%] before:[filter:blur(calc(0.8*1rem))]",

        // Background colors
        "bg-[linear-gradient(#FAF9F6,#FAF9F6),linear-gradient(#FAF9F6_50%,rgba(250,249,246,0.6)_80%,rgba(250,249,246,0)),linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))]",
        "dark:bg-[linear-gradient(#FAF9F6,#FAF9F6),linear-gradient(#FAF9F6_50%,rgba(250,249,246,0.6)_80%,rgba(250,249,246,0)),linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))]",

        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
} 